import { useActivitiesStyles, useModuleBEM } from "@b2bportal/core-themes";
import { CoreActivitiesComponent } from "@b2bportal/core-types";
import { useCancellationBanner } from "@tenant/activities";
import { Icon, InfoBanner } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./CancellationBanner.module.scss";

const COMPONENT_KEY = CoreActivitiesComponent.CancellationBanner;

export interface CancellationBannerProps {
  includeDeadline?: boolean;
  className?: string;
}

export const CancellationBanner = ({
  includeDeadline = false,
  className,
}: CancellationBannerProps = {}) => {
  const styles = useActivitiesStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);
  const { text, percentageRefundable, getSeverityAndIcon } =
    useCancellationBanner({
      includeDeadline,
    });

  if (!text.cancellationPolicy) return null;

  const { severity, iconName } = getSeverityAndIcon(percentageRefundable);

  return (
    <div className={clsx(block, className)}>
      <InfoBanner severity={severity} showIcon={false}>
        <Icon className={cn("icon")} iconName={iconName} />
        <span className={cn("text")}>{text.cancellationPolicy}</span>
      </InfoBanner>
    </div>
  );
};
